function isValidRGBValue(value: string | number) {
  return (
    typeof value === "number" &&
    !Number.isNaN(value) &&
    value >= 0 &&
    value <= 255
  );
}

export default function setRGBA(
  red: number,
  green: number,
  blue: number,
  alpha?: number
) {
  if (isValidRGBValue(red) && isValidRGBValue(green) && isValidRGBValue(blue)) {
    const color: {
      red: number;
      green: number;
      blue: number;
      alpha?: number;
    } = {
      red: red | 0,
      green: green | 0,
      blue: blue | 0
    };

    if (alpha && isValidRGBValue(alpha)) {
      color.alpha = alpha | 0;
    }

    return color;
  }

  return null;
}
